import * as React from 'react';
import style from '../style/WForm.less';

interface WFormFieldSelectOptAsRadioProps extends React.ClassAttributes<any> {
    value: any;
    options: Array<any>;
    disabled?: boolean;
    horizontal?: boolean;
    layout?: string;
    onChange(evt: any): void;
}

export interface WFormFieldSelectOptAsRadioState {
    ckRadios: any;
}

export class WFormFieldSelectOptAsRadio extends React.Component<WFormFieldSelectOptAsRadioProps, WFormFieldSelectOptAsRadioState> {
    constructor(props: any) {
        super(props);
        this.state = {
            ckRadios: this.prepareCkRadios()
        };
        this.onChange = this.onChange.bind(this);
        this.prepareCkRadios = this.prepareCkRadios.bind(this);
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (JSON.stringify(this.props.value) !== JSON.stringify(prevProps.value)) {
            this.setState({ ckRadios: this.prepareCkRadios() });
        }
    }

    prepareCkRadios() {
        const st: any = {};
        this.props.options.map((r: any) => {
            if (this.props.value && this.props.value.value === r.value) {
                st[r.value] = true;
            } else {
                st[r.value] = false;
            }
        });
        return st;
    }

    onChange(evt: any) {
        const key = evt.target.value;
        const ckRadios = this.state.ckRadios;
        Object.keys(ckRadios).map((k: string) => {
            if (k === key) {
                ckRadios[k] = true;
            } else {
                ckRadios[k] = false;
            }
        });
        this.setState({ ckRadios });
        // Callback
        const found = this.props.options.find((o: any) => o.value.toString() === key.toString());
        this.props.onChange(found);
    }

    render() {
        const { disabled, layout } = this.props;
        const flex: any = this.props.horizontal ? { display: 'flex', flexDirection: 'row' } : {};
        return (
            <div style={{ ...flex, width: 'auto' }}>
                {this.props.options.map((op: any) => {
                    const checked = this.state.ckRadios[op.value];
                    const backgroundColor: string = checked
                        ? (disabled ? '#aaa' : (
                            layout === 'sidebysideComplexGreen'
                                ? 'var(--color-button-bg)'// '#00b050'
                                : 'var(--color-button-bg)'// '#bccae3'
                            )
                        )
                        : 'white';
                    const styleOption: React.CSSProperties = {
                        backgroundColor, borderColor: backgroundColor,
                        ...(['sidebysideComplex', 'sidebysideComplexGreen'].indexOf(layout) !== -1 && !disabled && checked && { color: 'var(--color-button-text)' })
                    };
                    return (
                        <label key={op.value}>
                            <div className={style.optionAsRadio} style={styleOption}>
                                <input
                                    style={{ verticalAlign: 'bottom' }}
                                    type='radio'
                                    value={op.value}
                                    checked={checked}
                                    onChange={this.onChange}
                                    disabled={disabled}
                                />
                                {op.label}
                            </div>
                        </label>
                    );
                })
                }
            </div>
        );
    }
}
